export { pmaSvg, dtsSvg }

var pmaSvg = `<svg width="13" height="12" viewBox="0 0 13 12" fill="currentColor" display="block" xmlns="http://www.w3.org/2000/svg">
<path d="M0 7.82389H2.49952V12H0V7.82389ZM4.50801 5.47068H7.00754V12H4.50801V5.47068ZM13 3.11746H11.5166V12H9.01809V3.11746H7.53468L10.2684 0L13 3.11746Z"/>
</svg>
`;

var dtsSvg = `<svg width="14" height="12" viewBox="0 0 14 12" fill="none" display="block" xmlns="http://www.w3.org/2000/svg">
<path d="M9.418 0H0V11.289H13.836V0H9.418ZM4.336 10.289H1V8.3593H4.336V10.289ZM4.336 7.35925H1V5.05945H4.336V7.35925ZM4.336 4.0565H1V1.86413H4.336V4.0565ZM8.418 10.289H5.336V8.3593H8.418V10.289ZM8.418 7.35925H5.336V5.05945H8.418V7.35925ZM8.418 4.0565H5.336V1.86413H8.418V4.0565ZM12.836 10.289H9.418V8.3593H12.836V10.289ZM12.836 7.35925H9.418V5.05945H12.836V7.35925ZM12.836 4.0565H9.418V1.86413H12.836V4.0565Z" fill="#8C8C8C"/>
</svg>`
